import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as OtpActions from './otp.actions';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';

import { getAuth } from '../auth/auth.selectors';
import { OTPToken, OTPTokenCreateResponse } from './../../../app/@shared/models/otptoken.model';

@Injectable()
export class OtpEffects {
  constructor(private readonly actions$: Actions, private readonly store: Store, private readonly apiPublic: PublicPartnerApiService) { }

  loadOtps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OtpActions.loadOtps, OtpActions.createOtpsSuccess, OtpActions.validateOtpSuccess, OtpActions.removeOtpSuccess),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.get<{ otptokens: Partial<OTPToken>[] }>('/users/' + auth!.user_uuid + '/auths/otptokens', {}).pipe(
            map(result => {
              return OtpActions.loadOtpsSuccess({
                otps: result.otptokens
              });
            }),
            catchError(error => of(OtpActions.loadOtpsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  createOtps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OtpActions.createOtps),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.post<Partial<OTPTokenCreateResponse>>('/users/' + auth!.user_uuid + '/auths/otptokens', action.data).pipe(
            map((result) => {
              return OtpActions.createOtpsSuccess({
                data: result
              });
            }),
            catchError(error => of(OtpActions.createOtpsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  validateOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OtpActions.validateOtp),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.post<void>('/users/' + auth!.user_uuid + '/auths/otptokens/' + action.uuid + '/validate', { otp: action.token }).pipe(
            map(() => {
              return OtpActions.validateOtpSuccess();
            }),
            catchError(error => of(OtpActions.validateOtpFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  removeOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OtpActions.removeOtp),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.delete<void>('/users/' + auth!.user_uuid + '/auths/otptokens/' + action.uuid).pipe(
            map(() => {
              return OtpActions.removeOtpSuccess();
            }),
            catchError(error => of(OtpActions.removeOtpFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );
}
